'use client';

/* Don't import CSS files from the ‘swiper’ library. They're already imported in ‘styles/swiper.css’ */
import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { Slider, SliderProps } from 'molecules/Slider';
import styles from './Carousel.module.css';

export const DynamicCarousel: FC<PropsWithChildren<SliderProps>> = ({
  children,
  pagination,
  ...props
}) => {
  return (
    <Slider
      pagination={{
        dynamicBullets: true,
        dynamicMainBullets: 3,
        bulletClass: clsx('swiper-pagination-bullet', styles.dynamicBullet),
        bulletActiveClass: 'swiper-pagination-bullet-active',
        horizontalClass: styles.paginationContainerDynamic,
        ...(typeof pagination !== 'boolean' ? pagination : {}),
      }}
      {...props}
    >
      {children}
    </Slider>
  );
};
